import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import {version, bugsnagApiKey} from '../package.json';

export const configureBugsnag = () => {
  Bugsnag.start({
    apiKey: process?.env?.BUGSNAG_API_KEY || bugsnagApiKey,
    plugins: [new BugsnagPluginReact()],
    enabledReleaseStages: ['production', 'staging'],
    releaseStage: process?.env?.NODE_ENV || 'development',
    appVersion: version,
  });
};
